import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fields"
}
const _hoisted_2 = ["for"]

import { ref, onMounted } from 'vue';

import NcTextField from '@nextcloud/vue/components/NcTextField';

import { t } from '@services/l10n';

import type { IExif, IPhoto } from '@typings';

interface IField {
  field: keyof IExif;
  label: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EditExif',
  props: {
    photos: {},
    disabled: { type: Boolean }
  },
  emits: ["save"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const exif = ref<Record<keyof IExif, string> | null>(null);
const dirty = ref({} as Record<keyof IExif, boolean>);

const fields = ref([
  {
    field: 'Title',
    label: t('memories', 'Title'),
  },
  {
    field: 'Description',
    label: t('memories', 'Description'),
  },
  {
    field: 'Label',
    label: t('memories', 'Label'),
  },
  {
    field: 'Make',
    label: t('memories', 'Camera Make'),
  },
  {
    field: 'Model',
    label: t('memories', 'Camera Model'),
  },
  {
    field: 'LensModel',
    label: t('memories', 'Lens Model'),
  },
  {
    field: 'Copyright',
    label: t('memories', 'Copyright'),
  },
] as IField[]);

onMounted(() => {
  const exifInit = {} as NonNullable<typeof exif.value>;

  for (const field of fields.value) {
    reset(field, exifInit);
  }

  exif.value = exifInit;
});

function result() {
  const diff = {} as Record<keyof IExif, string>;
  for (const field of fields.value) {
    if (dirty.value[field.field]) {
      diff[field.field] = exif.value![field.field];
    }
  }
  return diff;
}

function label(field: IField) {
  return field.label + (dirty.value[field.field] ? '*' : '');
}

function placeholder(field: IField) {
  return dirty.value[field.field] ? t('memories', 'Empty') : t('memories', 'Unchanged');
}

function reset(field: IField, exifIn: typeof exif.value = null) {
  dirty.value[field.field] = false;

  // We use this to pass an object during initialization
  exifIn ??= exif.value!;

  // Check if all photos have the same value for this field
  const first = props.photos[0]?.imageInfo?.exif?.[field.field];
  if (props.photos.every((p) => p.imageInfo?.exif?.[field.field] === first)) {
    exifIn[field.field] = String(first ?? String());
  } else {
    exifIn[field.field] = String();
  }
}

__expose({ result });

return (_ctx: any,_cache: any) => {
  return (exif.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields.value, (field) => {
          return (_openBlock(), _createElementBlock("div", {
            key: field.field
          }, [
            _createElementVNode("label", {
              for: `exif-field-${field.field}`
            }, _toDisplayString(label(field)), 9, _hoisted_2),
            _createVNode(_unref(NcTextField), {
              class: "field",
              id: `exif-field-${field.field}`,
              disabled: __props.disabled,
              "label-outside": true,
              modelValue: exif.value[field.field],
              "onUpdate:modelValue": ($event: any) => ((exif.value[field.field]) = $event),
              placeholder: placeholder(field),
              onInput: ($event: any) => (dirty.value[field.field] = true),
              "trailing-button-icon": "close",
              "show-trailing-button": dirty.value[field.field],
              onTrailingButtonClick: ($event: any) => (reset(field)),
              onKeypress: _cache[0] || (_cache[0] = _withKeys(($event: any) => (emit('save')), ["enter"]))
            }, null, 8, ["id", "disabled", "modelValue", "onUpdate:modelValue", "placeholder", "onInput", "show-trailing-button", "onTrailingButtonClick"])
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})